module.exports = __webpack_public_path__ + "media/images/loading-f657825a2eeed04632b01ed85f528407.gif";